export function toPathString(path: string[]): string {
  return `${path.join('/')}`.replace('//', '/');
}
